import { SiqError } from "@models/app/helpers.model";

export interface AuthStateModel {
  siqAuth: string | null;
  cognitoAuth: string | null;
  refreshToken: string;
  username: string;
  userInfo: string;
  loading: boolean;
  loginError: SiqError | null;
  error: SiqError | null;
}

export const defaultAuthState = {
  siqAuth: null,
  cognitoAuth: null,
  refreshToken: '',
  username: '',
  userInfo: '',
  loading: false,
  loginError: null,
  error: null
};
